/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Canonical display-status filter values for portal publications.
 */
export enum PropertyPortalPublicationDisplayStatusFilter {
    ALL = 'ALL',
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    PAYMENT_PENDING = 'PAYMENT_PENDING',
    UNDER_REVIEW = 'UNDER_REVIEW',
    PAUSED = 'PAUSED',
    UNPUBLISHED = 'UNPUBLISHED',
    CLOSED = 'CLOSED',
    ERROR = 'ERROR',
}
